import React from 'react';
import './shared.css';

const SystemManuals: React.FC = () => {
  const manualCategories = [
    {
      title: 'BMW ISTA',
      description: 'BMW Integrated Service Technical Application manuals and procedures.',
      image: '/images/ista-manual.jpg'
    },
    {
      title: 'Mercedes Xentry',
      description: 'Mercedes-Benz diagnostic system documentation and procedures.',
      image: '/images/xentry-manual.jpg'
    },
    {
      title: 'Porsche PIWIS',
      description: 'Porsche Integrated Workshop Information System documentation.',
      image: '/images/piwis-manual.jpg'
    },
    {
      title: 'Audi/VW VAS',
      description: 'Volkswagen Audi Service documentation and diagnostic procedures.',
      image: '/images/vas-manual.jpg'
    }
  ];

  return (
    <div className="page-container">
      <div className="content-card">
        <h1>Training System Manuals</h1>
        <p>
          Access comprehensive technical documentation and system manuals for European 
          automotive diagnostic systems. Our manuals provide step-by-step procedures, 
          wiring diagrams, and technical specifications.
        </p>

        <div>
          <h3>Available Manuals</h3>
          <div className="grid grid-4">
            {manualCategories.map((category, index) => (
              <div key={index} className="card">
                <div style={{ height: 150, background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 15 }}>
                  <span style={{ color: '#999' }}>Manual Image</span>
                </div>
                <h4>{category.title}</h4>
                <p>{category.description}</p>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h3>Manual Categories</h3>
          <ul>
            <li><strong>Diagnostic Procedures:</strong> Step-by-step diagnostic workflows</li>
            <li><strong>Wiring Diagrams:</strong> Complete electrical schematics</li>
            <li><strong>Component Locations:</strong> Parts and sensor locations</li>
            <li><strong>Technical Specifications:</strong> System parameters and tolerances</li>
            <li><strong>Repair Procedures:</strong> Service and repair instructions</li>
            <li><strong>Programming Guides:</strong> Coding and programming procedures</li>
          </ul>
        </div>

        <div>
          <h3>Premium Access</h3>
          <p>
            System manuals are available to Premium members. Upgrade your membership 
            to access our complete library of technical documentation.
          </p>
          <a href="/membership" className="btn btn-large">
            Upgrade to Premium
          </a>
        </div>

        <div>
          <h3>Technical Support</h3>
          <p>
            Need help understanding a manual or procedure? Our technical support team 
            is available to assist you. Contact us at 800-660-7156 or visit our{' '}
            <a href="http://forum.aeuromotive.com/" target="_blank" rel="noopener noreferrer">
              technical forum
            </a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default SystemManuals;

